import React from "react";
import {
  Box,
  TextField,
  Button,
  LinearProgress,
  Paper,
  Stack,
  Typography,
  InputAdornment,
  IconButton,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import schoolLogo from "images/school_logo.png";
import ForgotPassword from "Components/Loginpage/Components/ForgotPassword";
import { POST_URL } from "Includes/urls";
import { postRequest } from "Includes/api/apicall";
import { DEFAULT_THEME } from "Constants";

function Loginpage(props) {
  const [name, setName] = React.useState("");
  const [pass, setPass] = React.useState("");
  const [error, setError] = React.useState({ name: "", pass: "" });
  const [disabled, setDisable] = React.useState(false);
  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const validation = () => {
    let valid = true;
    let err = { name: "", pass: "" };

    if (!name) {
      err.name = "Enter username";
      valid = false;
    }
    if (!pass) {
      err.pass = "Enter password";
      valid = false;
    }

    setError(err);
    return valid;
  };

  const loginButton = async (e) => {
    e.preventDefault();
    if (!validation()) return;

    setDisable(true);

    const postData = {
      username: name,
      password: pass,
    };

    const url = POST_URL.login.api;

    postRequest(url, postData, { ...props, apiKey: "login" }).then((res) => {
      if (res?.status === 200) {
        const data = res.data;

        localStorage.setItem("token", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));
        localStorage.setItem("menu", JSON.stringify(data.data.menu));
        localStorage.setItem("settings", JSON.stringify(data.data.settings));

        if (!localStorage.getItem("theme")) {
          localStorage.setItem("theme", DEFAULT_THEME);
        }

        window.location = "/dashboard";
      }
      setDisable(false);
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") setName(value);
    else setPass(value);

    setError({ ...error, [name]: "" });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #1e3c72, #2a5298)",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 400,
          p: 4,
          borderRadius: 4,
          backdropFilter: "blur(12px)",
          background: "rgba(255,255,255,0.95)",
          position: "relative",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
        }}
      >
        {disabled && (
          <LinearProgress
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
            }}
          />
        )}

        <Stack spacing={3}>
          {/* LOGO */}
          <Box textAlign="center">
            <img src={schoolLogo} alt="logo" width={70} />
          </Box>

          {/* HEADING */}
          <Box textAlign="center">
            <Typography variant="h5" fontWeight={600}>
              Welcome Back
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Sign in to continue
            </Typography>
          </Box>

          {/* FORM */}
          <Box component="form" onSubmit={loginButton}>
            <Stack spacing={2}>
              <TextField
                label="Username"
                name="name"
                value={name}
                onChange={handleChange}
                error={!!error.name}
                helperText={error.name}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <AccountCircleIcon />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Password"
                name="pass"
                value={pass}
                onChange={handleChange}
                type={values.showPassword ? "text" : "password"}
                error={!!error.pass}
                helperText={error.pass}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setValues({
                            showPassword: !values.showPassword,
                          })
                        }
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={disabled}
                startIcon={<LockOutlinedIcon />}
                sx={{
                  py: 1.2,
                  borderRadius: 2,
                  fontWeight: 600,
                  background:
                    "linear-gradient(135deg, #667eea, #764ba2)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #5a67d8, #6b46c1)",
                  },
                }}
              >
                Sign In
              </Button>
            </Stack>
          </Box>

          {/* FORGOT PASSWORD */}
          <Box textAlign="center">
            <ForgotPassword />
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
}

export default Loginpage;